import NavLinkAdapter from '@fuse/core/NavLinkAdapter';
import { alpha, styled } from '@mui/material/styles';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import FuseNavBadge from '../../FuseNavBadge';
import FuseSvgIcon from '../../../FuseSvgIcon';
import { Box } from '@mui/material';

const Root = styled(ListItem)(({ theme, ...props }) => ({
  position: 'relative',
  height: 38,
  width: '100%',
  borderRadius: '8px',
  paddingRight: 12,
  paddingLeft: 12,
  paddingTop: 10,
  paddingBottom: 10,
  color: theme.palette.text.primary,
  cursor: 'pointer',
  textDecoration: 'none!important',
  '&:hover': {
    color: theme.palette.text.nav,
    backgroundColor: theme.palette.mode === 'light'
      ? theme.palette.violet[100]
      : 'rgba(255, 255, 255, .1)!important',
  },
  '&.active': {
    color: theme.palette.text.nav,
    border: '1px solid',
    borderColor: theme.palette.violet[300],
    backgroundColor:
      theme.palette.mode === 'light'
        ? theme.palette.violet[100]
        : 'rgba(255, 255, 255, .1)!important',
    pointerEvents: 'none',
    transition: 'border-radius .15s cubic-bezier(0.4,0.0,0.2,1)',
    '& > .fuse-list-item-text-primary': {
      color: 'inherit',
    },
    '& > .fuse-list-item-icon': {
      color: 'inherit',
    },
  },
  
  '& >.fuse-list-item-icon': {
    marginRight: 12,
    color: 'inherit',
  },
  '& > .fuse-list-item-text': {},
}));

function FuseNavVerticalItem(props) {
  const { item, nestedLevel, onItemClick } = props;

  const itempadding = nestedLevel > 0 ? 38 + nestedLevel * 16 : 16;

  return useMemo(
    () => (
      <Root
        button
        component={NavLinkAdapter}
        to={item.url || ''}
        activeClassName={item.url ? 'active' : ''}
        onClick={() => onItemClick && onItemClick(item)}
        end={item.end}
        itempadding={itempadding}
        role="button"
        sx={item.sx}
        disabled={item.disabled}
      >
        <Box
          className='fuse-menu-box'
          width="6px"
          height={40}
          position="absolute"
          left="-12px"
          top="0"
        />
        {item.icon && (
          <FuseSvgIcon
            size={16}
            className={clsx('fuse-list-item-icon shrink-0', item.iconClass)}
            color="action"
          >
            {item.icon}
          </FuseSvgIcon>
        )}

        <ListItemText
          className="fuse-list-item-text"
          primary={item.title}
          secondary={item.subtitle}
          sx={{
            '.MuiTypography-root': {
              color: 'inherit',
            },
          }}
          classes={{
            primary: 'text-13 font-medium truncate',
            secondary: 'text-11 font-medium leading-normal truncate',
          }}
        />
        {item.badge && <FuseNavBadge badge={item.badge} />}
      </Root>
    ),
    [item, itempadding, onItemClick]
  );
}

FuseNavVerticalItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    icon: PropTypes.string,
    url: PropTypes.string,
  }),
};

FuseNavVerticalItem.defaultProps = {};

const NavVerticalItem = FuseNavVerticalItem;

export default NavVerticalItem;
